import * as React from "react";
import type { SVGProps } from "react";
const SvgEarth = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#earth_svg__a)">
      <path d="M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.49 10 10-4.49 10-10 10m0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8" />
      <path d="M16.96 15.83h-1.35c-.46 0-.86-.31-.97-.76l-1.15-4.6h-.02c-.54.02-1.02-.4-1.04-.96-.02-.55.41-1.02.96-1.04l.84-.04c.51-.01.9.3 1.01.76l1.14 4.55.45-.94-.76-1.59c-.16-.34-.12-.75.12-1.05l.96-1.23c.17-.21.41-.35.68-.38.28-.03.54.05.75.23l3.08 2.58c.42.35.48.98.12 1.41a1 1 0 0 1-1.41.12l-2.14-1.79.61 1.27c.13.27.13.59 0 .86l-.96 2.02c-.17.35-.52.57-.9.57z" />
      <path d="M11.53 13.63c-.26 0-.51-.1-.71-.29a.996.996 0 0 1 0-1.41l.22-.22-.36-1.32-1.11 1.11a1 1 0 0 1-.71.29h-2.7a.98.98 0 0 1-.75-.34.98.98 0 0 1-.24-.79l.34-2.7c.06-.5.49-.88.99-.88h.58l.38-.41c.12-.13.27-.22.44-.28l1.45-.44.25-1.26a.999.999 0 0 1 1.96.38l-.36 1.85a.99.99 0 0 1-.69.76l-1.76.54-.49.53c-.19.2-.46.32-.73.32H7.4l-.09.7h1.15l1.06-1.06c.1-.1.21-.17.34-.22l1.12-.45c.26-.11.56-.09.82.03.25.13.44.36.52.63l.82 3.01c.09.35 0 .72-.26.97l-.63.63c-.2.2-.45.29-.71.29z" />
      <path d="M17.46 19.88h-3.2a1 1 0 0 1-.95-.68l-1.13-3.33h-.23l-1.03 1.01a.99.99 0 0 1-.8.29.98.98 0 0 1-.73-.43l-1.17-1.71-1.93-.49-2.36 1.18a.99.99 0 0 1-1.34-.45.993.993 0 0 1 .45-1.34l2.7-1.35c.21-.11.46-.13.69-.07l2.66.67c.24.06.44.2.58.4l.71 1.03.5-.5c.2-.2.49-.31.77-.29l1.35.09a1 1 0 0 1 .88.68L15 17.87h2.48c.55 0 1 .45 1 1s-.45 1-1 1zM10.58 5.89c-.26 0-.51-.1-.71-.29a.996.996 0 0 1 0-1.41l1.89-1.89a.996.996 0 1 1 1.41 1.41L11.28 5.6c-.2.2-.45.29-.71.29z" />
    </g>
    <defs>
      <clipPath id="earth_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgEarth;
